module.exports = __webpack_public_path__ + "static/media/bannerImagePublicDirectory.3ea159ba.png";